import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHamburgerMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 33,
	height: 22,
	viewBox: "0 0 33 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 0.5C1.17157 0.5 0.5 1.17157 0.5 2C0.5 2.82843 1.17157 3.5 2 3.5V0.5ZM31.2857 3.5C32.1141 3.5 32.7857 2.82843 32.7857 2C32.7857 1.17157 32.1141 0.5 31.2857 0.5V3.5ZM2 9.5C1.17157 9.5 0.5 10.1716 0.5 11C0.5 11.8284 1.17157 12.5 2 12.5V9.5ZM31.2857 12.5C32.1141 12.5 32.7857 11.8284 32.7857 11C32.7857 10.1716 32.1141 9.5 31.2857 9.5V12.5ZM2 18.5C1.17157 18.5 0.5 19.1716 0.5 20C0.5 20.8284 1.17157 21.5 2 21.5V18.5ZM31.2857 21.5C32.1141 21.5 32.7857 20.8284 32.7857 20C32.7857 19.1716 32.1141 18.5 31.2857 18.5V21.5ZM2 3.5H31.2857V0.5H2V3.5ZM2 12.5H31.2857V9.5H2V12.5ZM2 21.5H31.2857V18.5H2V21.5Z",
		fill: "#303651"
	})
});
export default SvgHamburgerMenu;
